// ** Custom Components
import { Icon } from "components/icons";
import Text from "components/typography/Text";

// ** Utils & Helpers
import pseudoFormat from "utils/pseudoFormat";

// #####################################################

export default ({ number, withZero, color, ...rest }) => {
	return (
		<Text textNowrap {...rest}>
			<Text block mx={1}>
				<Icon name="eye" color={color} />
			</Text>
			{number > 0 || withZero ? (
				<Text block>{pseudoFormat(number)}</Text>
			) : null}
		</Text>
	);
};

// #####################################################
